// NOTE -- this is just the climate/spatial api stuff;
// authentication api calls are handled in auth.ts and token.ts (need to merge?)

import instance from "src/services/instance"

// TODO - consider using loading indicator while waiting on async response https://mui.com/material-ui/react-button/#loading-button
export function basicOverlay(latlng: any) {
    const out = instance.get("overlay/?format=json&latitude=" + latlng.lat + "&longitude=" + latlng.lng).then((response) => response.data);
    console.log("Api output 1: " + out);
    return (out);
}

export function load_asset(latlng: any) {
    const out = instance.post("load_asset/", { 'lat': latlng.lat, 'long': latlng.lng }).then((response) => response.data);
    console.log("Loaded asset");
    return (out);
}

export function delete_asset(latlng: any) {
    const out = instance.post("delete_asset/", { 'lat': latlng.lat, 'long': latlng.lng });
    console.log("Deleted asset");
    return (out);
}

export function delete_assets() {
    const out = instance.post("delete_assets/");
    console.log("Deleted assets");
    return (out);
}

export function delete_selected_assets(id_list: any) {
    const out = instance.post("delete_selected_assets/", { 'id_list': id_list });
    console.log("Deleted selected assets");
    return (out);
}

export function rename_asset(id: any, new_name: any) {
    const out = instance.post("rename_asset/", { 'id': id, 'new_name': new_name });
    console.log("Rename asset");
    return (out);
}

export function get_assets() {
    const out = instance.get("get_assets/").then((response) => response.data);
    console.log("Got assets");
    return (out);
}
